import PrivilegesIcon from '@assets/images/line-item/privileges.svg';
import { Tag, TagProps } from '@components/Tag/Tag';

export function PrivilegeTag({ className = '' }: TagProps) {
	return <Tag className={`${className} border-sia-blue text-sia-blue text-base`} classIcon='h-4 w-4' icon={<PrivilegesIcon />} name='PRIVILEGE' />;
}

export function PrivilegeBorderTag({ className = '' }: TagProps) {
	return (
		<Tag
			className={`${className} pl-[3px] pr-1 py-[2px] border-sia-blue text-sia-blue border rounded-full text-xs`}
			classIcon='pl-0.5 h-3 w-3'
			icon={<PrivilegesIcon />}
			name='PRIVILEGE'
		/>
	);
}
